import { ReactComponent } from "./ic_sort_asc.svg";

interface Props {
  fill?: string;
}

const SortAscFillIcon: React.FC<Props> = ({ ...rest }) => {
  return <ReactComponent {...rest} />;
};

export default SortAscFillIcon;
